import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class OfficerCallOffPenaltyRulesService extends AbstractService {
	static penaltyRulesApi = NexusService.officerCallOffPenaltyRulesApi;

	static getPenalties(id) {
		return this.penaltyRulesApi
			.getOfficerCallOffPenaltyRules({ id })
			.then(response => ({ data: response }));
	}

	static postPenalties(data) {
		const createReq = {
			officerCallOffPenaltyRulesCreatePayload: {
				OrganizationId: data.OrganizationID,
				JurisdictionId: data.JurisdictionId,
				EnforceOfficerPenalty: data.EnforceOfficerPenalty,
				DaysToConsider: data.DaysToConsider,
				MonthToDate: data.MonthToDate,
				YearToDate: data.YearToDate,
				SuspensionRules: data.SuspensionRules,
			},
		};

		return this.penaltyRulesApi
			.createOfficerCallOffPenaltyRules(createReq)
			.then(response => ({ data: response }));
}

	static updatePenalties(data) {
		const updateReq = {
			id: data.Id,
			officerCallOffPenaltyRulesUpdatePayload: {
				OrganizationId: data.OrganizationId,
				JurisdictionId: data.JurisdictionId,
				EnforceOfficerPenalty: data.EnforceOfficerPenalty,
				DaysToConsider: data.DaysToConsider,
				MonthToDate: data.MonthToDate,
				YearToDate: data.YearToDate,
				SuspensionRules: data.SuspensionRules,
			},
		};

		return this.penaltyRulesApi.updateOfficerCallOffPenaltyRules(updateReq);
	}
}
